export default __webpack_public_path__ + "static/media/404.11e0be1b.png";